import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faChartBar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton } from "bootstrap-vue";
import { computed } from "vue";
import localize from "@/utils/localization";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ObjectStoreActions',
    props: {
        data: null
    },
    emits: ["view-item"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faChartBar);
        const label = computed(() => props.data.id);
        const viewDetailsIcon = computed(() => "chart-bar");
        function onViewItem() {
            emit("view-item", props.data.id);
        }
        return { __sfc: true, props, label, viewDetailsIcon, emit, onViewItem, FontAwesomeIcon, BButton, localize };
    }
});
